import React from 'react';

export const FilterByTitle = () => {
  return <p>Any combination of data can be used to search.</p>;
};
